<template>
  <section>
    <div class="mod-block">
      <h3 class="title">子商品档案</h3>
      <el-button type="success" @click="addSubProduct">添加子商品</el-button>
      <el-form :model="tableData" ref="form">
        <el-form-item prop="list" required :rules="[{validator: $validate.required, message: '子商品档案不能为空'}]">
          <el-table :data="tableData.list" style="max-width: 1000px;" v-loading="loading" size="mini" max-height="300">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="childItem" label="子商品编码"></el-table-column>
            <el-table-column prop="childItemDesc" label="子商品名称" min-width="180"></el-table-column>
            <!-- 差异值 begin -->
            <el-table-column label="差异值" min-width="180" v-for="(item, index) in formDiff" :key="index">
              <template slot-scope="scope">{{getText(scope.row, index)}}</template>
            </el-table-column>
            <!-- 差异值 end -->
            <el-table-column prop="barcode" label="商品条码"></el-table-column>
            <el-table-column prop="barcodeType" label="编码类型">
              <template slot-scope="scope">{{$selectMap.getName('barcode', scope.row.barcodeType)}}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-link type="primary" @click="edit(scope.row, scope.$index)">编辑</el-link>
                <el-link type="danger" @click="del(scope.$index)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增 -->
    <SubCommodityAdd ref="addItem" @sure="handleAdd" :dataList="tableData.list" :selectIndex="selectIndex"></SubCommodityAdd>
  </section>
</template>
<script>
  import SubCommodityAdd from './sub-commodity-add.vue'
  export default {
    inject: ['getMod', 'getComData'],
    components: {SubCommodityAdd},
    data () {
      return {
        selectIndex: 'null',
        loading: false,
        formDiff: [],
        tableData: {list: []},
        // 最终字段
        form: {
          list: []
        },
        // 第二级key,value对 (与diff-group第一级字段一致)
        formAr2: [],
        // 第三级key,value对
        formAr3: [
          ['subDiffKeyOne', 'subDiffValueOne'],
          ['subDiffKeyTwo', 'subDiffValueTwo'],
          ['subDiffKeyThree', 'subDiffValueThree'],
          ['subDiffKeyFour', 'subDiffValueFour']
        ]
      }
    },
    methods: {
      getText (item, index) {
        let obj = item.formDiff[index]
        return obj['map3'][obj.v3].diffDesc
      },
      flat (arr) {
        return arr.flat(Infinity)
      },
      addSubProduct () {
        this.selectIndex = 'null'
        this.$refs.addItem.show()
      },
      edit (item, index) {
        this.selectIndex = index
        this.$refs.addItem.editROw(item)
      },
      del (index) {
        this.$confirm('确认删除选中商品?').then(rs => {
          this.tableData.list.splice(index, 1)
          this.formateFormData()
        }).catch(rs => {})
      },
      handleAdd ({list, formDiff}) {
        this.formDiff = formDiff
        if (this.selectIndex != 'null') {
          this.$set(this.tableData.list, this.selectIndex, list)
        } else {
          this.tableData.list.push(list)
        }
        this.formateFormData()
      },
      // 转换成后端所需数据
      formateFormData () {
        let ar = this.tableData.list || []
        let newAr = []
        let keys2 = this.formAr2
        let keys3 = this.formAr3
        let ars = [...this.flat(this.formAr2), ...this.flat(this.formAr3)]
        ar.forEach((item, index) => {
          let obj = {...item}
          // 重置叶子节点数据(清除旧数据)
          ars.forEach(item2 => {
            delete obj[item2]
          })
          let newObj = {}
          obj.formDiff.forEach(item2 => {
            let textKey2 = keys2[item2.degree][0]
            let valueKey2 = keys2[item2.degree][1]
            let textKey3 = keys3[item2.degree][0]
            let valueKey3 = keys3[item2.degree][1]
            obj[textKey2] = item2.map2[item2.v2].diffGroupDesc
            obj[valueKey2] = item2.v2
            obj[textKey3] = item2.map3[item2.v3].diffDesc
            obj[valueKey3] = item2.v3
          })
          newObj = {...obj}
          delete newObj.formDiff
          newAr.push(newObj)
        })
        this.form.list = newAr
      },
      cloneObj (obj) {
        return JSON.parse(JSON.stringify(obj))
      }
    },
    mounted () {
      let $itemDiffModel = this.getMod('itemDiffModel')
      this.formAr2 = $itemDiffModel.formAr
      $itemDiffModel.$on('loaded', () => {
        // 编辑
        let itemChildDiffList = this.cloneObj(this.getComData().editData.itemChildDiffList)
        if (itemChildDiffList && itemChildDiffList.length > 0) {
          this.tableData.list = this.cloneObj(itemChildDiffList)
          this.form.list = this.cloneObj(itemChildDiffList)
          this.formDiff = this.cloneObj($itemDiffModel.formDiff.list.filter(item => item.v2))
          let ars = [...this.flat(this.formAr2), ...this.flat(this.formAr3)]
          this.tableData.list.forEach(item => {
            // 重组formDiff数据, 取得v3的值
            let v3Map = {}
            this.formAr3.forEach((item2, index2) => {
              if (item[item2[1]]) {
                v3Map[index2] = item[item2[1]]
              }
            })
            this.formDiff.forEach((item2, index2) => {
              item2.v3 = v3Map[item2.degree]
            })
            this.$set(item, 'formDiff', this.cloneObj(this.formDiff))
            // 重置叶子节点数据(清除旧数据)
            ars.forEach(item2 => {
              delete item[item2]
            })
          })
        }
      })
      $itemDiffModel.$on('updated', () => {
        this.tableData.list = []
        this.form.list = []
        this.formDiff = []
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 25px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    /deep/ .el-table th.el-table__cell {
      background-color: #D2E8F2;
      color: #333;
    }
  }
  .el-table {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/diff/sub-commodity-archives.vue